<template>
  <div>
    <div class='SDAU_style header' style="padding-bottom: 0px;">
      <span style='display:flex;flex-direction:row;align-items:center;'>
        <img style='width: 16px;height:16px;' src="../../assets/images/icon_telephone.png">
        <span class='phone'>0538-8247770</span>
      </span>
      <span style='display:flex;flex-direction:row;align-items:center;'>
        <img v-if='!ifLogin' style='width: 16px;height:16px;' src="../../assets/images/icon_person_fill.png">
        <span class='loginMsg'>
          <span v-if='!ifLogin' style='margin-right:36px;'>
            <el-button style='cursor: pointer;' type='text' v-Login='login'>登录</el-button>
            <span style='margin:0 5px 0 5px;color:#FFFFFF;cursor: default'>|</span>
            <el-button @click="goRegister" style='cursor: pointer;' type='text'>注册</el-button>
          </span>
          <span v-else style='display:flex;flex-direction:row;align-items:center;font-family:Source Han Sans SC'>
            <img v-if='$store.getters.userInfo' style='width: 24px;height: 24px; margin-right:10px'
              :src="baseurl + '/' + $store.getters.userInfo.avatar">
            <img v-else style='width: 24px;height: 24px; margin-right:10px' src="@/assets/images/icon_portrait.png">
            <span v-if='$store.getters.userInfo' style='cursor: default;margin-right:10px'>{{
                          $store.getters.userInfo.nickName }}
            </span>
            <span v-else style='cursor: default;margin-right:10px'>暂无数据
            </span>
            <el-button style="margin-top:2px" type='text' size="medium" @click='LoginOut'>[退出登录]</el-button>
            <span style='margin:0 14px 0 14px;color:#FFFFFF;cursor: default'>|</span>
          </span>
          <span style='cursor: default;display:inline-block;width: 284px;'>{{ headerText }}</span>
        </span>
      </span>
    </div>
    <div class='SDAU_style headerTab'>
      <ul style='display:flex;flex-direction:row;align-items:center;margin-left: -50px;'>
        <img @click="toHome" style='cursor: pointer;' src="../../assets/images/logo.png">
        <li style='margin:0 11px 0 11px;color:#E2E2E2;cursor: default;font-size:20px'>|</li>
        <li class='logoText' style='cursor: default;'>植保学院仪器共享平台</li>
      </ul>
      <el-tabs v-model="activeName" @tab-click="rotuerSwitch">
        <el-tab-pane label="首页" name="home"></el-tab-pane>
        <el-tab-pane label="资料查看" name="dataViewing"></el-tab-pane>
        <el-tab-pane label="仪器设备" name="eqment"></el-tab-pane>
        <el-tab-pane label="个人中心" name="userCenter"></el-tab-pane>
      </el-tabs>
    </div>
    <register v-if="showRegister" :showRegister="showRegister" @close="showRegister = false"></register>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import SDAU from '@/utils/SDAU'
const { APIURl } = require('@/utils/apiUrl')
export default {
  name: 'navbar',
  data() {
    return {
      headerText: '',
      activeName: "",
      ifLogin: false,
      baseurl: '',
      showRegister: false,
    }
  },
  methods: {
    init() {
      this.ifLogin = getToken()
      this.headerText = SDAU.getCurrentDate()
      this.activeName = this.$route.name
      this.baseurl = APIURl
      getToken() ? this.$store.dispatch('user/setUsrmsg') : ''
    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    LoginOut() {
      this.$confirm("确定退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch('user/logout').then(() => {
          setTimeout(() => {
            this.$route.name == 'home' || this.$route.name == 'eqment' ? '' : this.$router.replace({ path: '/' })
            location.reload();
          }, 100)
        })
      }).catch((err) => {
      })
    },
    rotuerSwitch(data) {
      !getToken() && (data.name == 'userCenter' || data.name == 'dataViewing') ? (this.$eventBus.$emit('goLogin', true), setTimeout(() => { this.activeName = this.$route.name })) : data.name == 'home' ? this.$router.push({ path: '/' }) : this.$router.push({ path: '/' + data.name })
    },
    login() {
    },
    goRegister() {
      this.showRegister = true
    },
  },
  created() {
    this.init()
  },
  watch: {
    $route(to, from) {
      this.activeName = to.name
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  height: 64px;
  line-height: 64px;
  background: #3864A2;
  display: flex;
  justify-content: space-between;

  .phone {
    width: 164px;
    font-size: 18px;
    font-family: DIN;
    font-weight: 500;
    line-height: 31px;
    color: #ffffff;
    opacity: 1;
    padding-left: 5px;
  }

  .loginMsg {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: DIN;
    font-weight: 500;
    line-height: 31px;
    color: #ffffff;
    opacity: 5;
    padding-left: 5px;
  }
}

::v-deep.headerTab {
  .el-tabs__nav {
    line-height: 50px;
    width: 460px;
    display: flex;
    justify-content: space-between;
    margin-top: 10%;
  }

  .el-tabs__active-bar {
    background-color: transparent !important;
  }

  /*去掉tabs底部的下划线*/
  .el-tabs__nav-wrap::after {
    position: static !important;
  }

  .el-tabs__item {
    font-weight: 500;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    opacity: 1;
  }

  height: 120px;
  line-height: 120px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;

  .logoText {
    width: 350px;
    height: 46px;
    font-size: 24px;
    font-family: Source Han Serif CN;
    font-weight: 700;
    line-height: 46px;
    color: #188335;
    letter-spacing: 3px;
  }

  // .routerTab {
  //   display: flex;
  //   justify-content: space-between;
  //   .el-button {
  //     color: #333333;
  //   }
  //   .el-button:hover {
  //     color: #188335;
  //   }
  //   .el-button:focus {
  //     color: #188335;
  //   }
  // }
}
</style>